/* eslint-disable react/no-danger */
/* eslint-disable @next/next/no-page-custom-font */
import parse from "html-react-parser";
import { seoFlightsCss } from "../../utils/stylesUtil/seoFlights";
import { topOverlayCSS } from "../../utils/stylesUtil/topOverlay";
import { ab } from "../../public/js/core/abMock";

export const appendHeadCityCountryDT = (props) => {
  const {
    serviceWorker,
    template,
    state,
    jsSettingJson,
    initial_css: initialCSS,
    appConfig,
    tokenJson,
    apiUrl,
    appData,
    ccde
  } = props || {};
  let cssPath;
  let jsPath;
  // let imagePath;
  // let minExt;
  let topOverlayPath;
  let robotMeta = "";
  if (appConfig && appConfig.liveMode) {
    cssPath = `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/css`;
    jsPath = `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js`;
    // imagePath = `${appConfig.imagePath}/images`;
    // minExt = '.min';
    topOverlayPath = `${jsPath}/top_overlay.min.js`;
    if (template && template.robotic_tag) {
      if (!state?.destinationPicker?.monthsData || state?.destinationPicker?.monthsData.length === 0) {
        robotMeta = '<meta name="robots" content="noindex, nofollow">';
      } else if (state?.destinationPicker?.monthsData.length > 0) {
        robotMeta = '<meta name="robots" content="index, follow">';
      }
    } else {
      robotMeta = '<meta name="robots" content="index, follow">';
    }
  } else {
    // eslint-disable-next-line no-unused-vars
    cssPath = "http://localhost:3000/_next/static/css";
    // eslint-disable-next-line no-unused-vars
    jsPath = "http://localhost:3000/_next/static/js";
    // imagePath = '/images';
    // minExt = '';
    topOverlayPath = "http://localhost:3000/_next/static/js/top_overlay.min.js";
  }
  const tokenJsonString =
    tokenJson && tokenJson.length !== 0
      ? `var tokenJson = ${JSON.stringify(tokenJson)}`
      : `var tokenJson = {"dest_country_code":"${tokenJson.tokensList.dest_country_code}","src_city_code": "${tokenJson.tokensList.src_city_code}","dest_country_name" :"${tokenJson.tokensList.dest_country_name}","src_city_name" :"${tokenJson.tokensList.src_city_name}"};`;
  const serviceWorkerString = appConfig.liveMode === true ? serviceWorker : "";
  return (
    <>
      {parse(robotMeta)}
      <link rel="preconnect" href="//jsak.mmtcdn.com" crossOrigin />
      <link rel="preconnect" href="//cssak.mmtcdn.com" crossOrigin />
      <link rel="preconnect" href="//imgak.mmtcdn.com" crossOrigin />
      <link rel="preconnect" href="//fonts.googleapis.com" crossOrigin />
      <link rel="preconnect" href="https://fonts.gstatic.com" />
      <link href={`${cssPath}/header.min.css`} rel="stylesheet" />
      <link
        href="https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap"
        rel="stylesheet"
      />
      <style dangerouslySetInnerHTML={{ __html: topOverlayCSS}} />
      <style dangerouslySetInnerHTML={{ __html: seoFlightsCss}} />
      <style dangerouslySetInnerHTML={{ __html: initialCSS}} />
      <script
        dangerouslySetInnerHTML={{
          __html: `
      window.urlParams = '${apiUrl}';
      window.showLeaveIntent = true;
      window.isPWA = false;
      window.isProduction = 'true';
      window.page = "destinationPicker";
      window.countryCode = '${ccde}';
      window.url ='${apiUrl}';
      window.appData = ${JSON.stringify(appData)};
      window.AB=${JSON.stringify(ab)};
      window.jsSetting = ${JSON.stringify(jsSettingJson)};
      var jsSettingJson = ${JSON.stringify(jsSettingJson)};
      ${tokenJsonString}
      `
        }}
      />
      <script dangerouslySetInnerHTML={{ __html: `${serviceWorkerString}` }} />
      <script defer type="text/javascript" src={`${topOverlayPath}`} />
    </>
  );
};
